import { Controller } from "@hotwired/stimulus"

// Interruttore «Semplice» / «Completa» (ModalitaContext.js dell'originale): cambia subito data-modalita
// sul <body> e sul gruppo, poi salva con PUT /api/me/preferenze, senza ricaricare la pagina.
// Le pagine leggono document.body.dataset.modalita e possono ascoltare l'evento "modalita:cambiata".
export default class extends Controller {
  static targets = ["pulsante"]
  static classes = ["attiva", "inattiva"]

  cambia(event) {
    event.preventDefault()
    const m = event.currentTarget.value
    if (m !== "semplice" && m !== "completa") return
    document.body.dataset.modalita = m
    this.element.dataset.modalita = m
    this.pulsanteTargets.forEach((b) => {
      const on = b.value === m
      b.setAttribute("aria-pressed", String(on))
      b.classList.remove(...(on ? this.inattivaClasses : this.attivaClasses))
      b.classList.add(...(on ? this.attivaClasses : this.inattivaClasses))
    })
    window.dispatchEvent(new CustomEvent("modalita:cambiata", { detail: { modalita: m } }))
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/api/me/preferenze", {
      method: "PUT",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json", ...(token ? { "X-CSRF-Token": token } : {}) },
      body: JSON.stringify({ modalita: m }),
    }).catch(() => {})
  }
}
